import React, { PropsWithChildren } from 'react';
import theme from './SettingsSection.module.scss';

interface SettingsSectionProps extends PropsWithChildren {}

const SettingsSection: React.FC<SettingsSectionProps> = ({ children }) => {
    return <div className={theme.section}>{children}</div>;
};

export default SettingsSection;
